import { feedItems } from "@/mocks/gossip";
import SectionHeading from "./SectionHeading";

const catClass: Record<string, string> = {
  实锤: "bg-accent-100 text-accent-700",
  新瓜: "bg-primary-100 text-primary-700",
  更新: "bg-secondary-100 text-secondary-700",
  对线: "bg-background-200 text-foreground-600",
  旧料: "bg-background-200 text-foreground-600",
};

export default function FeedSection() {
  return (
    <section id="kuaixun" className="border-y border-background-200/70 bg-background-100">
      <div className="container-x py-10 md:py-14">
        <div className="grid grid-cols-1 gap-6 lg:grid-cols-3 md:gap-8">
          {/* header col */}
          <div className="lg:col-span-1">
            <SectionHeading
              kicker="滚动更新 · 短讯并行"
              title="实时快讯"
              desc="新到的瓜、补上的锤、反转的帖，都在这一屏按分钟滚动。横排小卡片信息量大，适合抽空扫一眼，看到感兴趣的就点进对应合集。"
            />
            <div className="mt-2 flex flex-wrap gap-2">
              {["实锤", "新瓜", "更新", "对线", "旧料"].map((c) => (
                <span
                  key={c}
                  className={`inline-flex items-center gap-1 rounded-full px-3 py-1 text-xs font-semibold whitespace-nowrap ${catClass[c]}`}
                >
                  <span className="h-1.5 w-1.5 rounded-full bg-current"></span>
                  {c}
                </span>
              ))}
            </div>
            <div className="mt-6 rounded-xl border border-background-200 bg-background-50 p-4 text-sm leading-relaxed text-foreground-600">
              <p className="flex items-center gap-2 font-semibold text-foreground-950">
                <i className="ri-refresh-line text-accent-600"></i>自动刷新中
              </p>
              <p className="mt-2 text-[13px]">
                上次抓取 21:40 · 今日已更新 <span className="font-semibold text-primary-600">39</span> 条短讯，无新增时会提示去目录翻归档。
              </p>
            </div>
          </div>

          {/* feed col */}
          <div className="lg:col-span-2">
            <div className="grid grid-cols-1 gap-3 sm:grid-cols-2 md:gap-4">
              {feedItems.map((f) => (
                <a
                  key={f.text}
                  href="#shilu"
                  className="group flex flex-col rounded-xl border border-background-200 bg-background-50 p-4 transition-colors hover:border-primary-300"
                >
                  <div className="flex items-center gap-2 text-xs">
                    <span
                      className={`inline-flex items-center rounded-md px-2 py-0.5 font-semibold whitespace-nowrap ${catClass[f.cat]}`}
                    >
                      {f.cat}
                    </span>
                    <span className="inline-flex items-center gap-1 text-foreground-400">
                      <i className="ri-time-line text-sm"></i>
                      {f.time}
                    </span>
                  </div>
                  <p className="mt-2.5 text-sm leading-relaxed text-foreground-700 group-hover:text-foreground-950">
                    {f.text}
                  </p>
                  <span className="mt-2.5 inline-flex items-center gap-1 text-xs font-medium text-primary-600 opacity-0 transition-opacity group-hover:opacity-100 whitespace-nowrap">
                    去看这条<i className="ri-arrow-right-line"></i>
                  </span>
                </a>
              ))}
            </div>
            <div className="mt-5 flex justify-center">
              <a
                href="#topics"
                className="inline-flex items-center gap-2 rounded-md border border-background-300 bg-background-50 px-5 py-2.5 text-sm font-semibold text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-600 whitespace-nowrap"
              >
                <i className="ri-more-2-fill"></i>加载更早快讯
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}